const initialState = {
    auth : null,
    selected_promotion_code : null,
}

const authReducer = (state = initialState, action) => {
    switch(action.type){
        case 'SET_AUTH':
            return {...state, auth : action.auth}
        case 'SELECT_PROMOTION_CODE' :
            return {...state, selected_promotion_code : action.promotion_code}
        default :
            return state;
    }
}

export default authReducer;